@if (formGroup && controlName) {
  <!-- Modo form: patchea el form control -->
  <div
    [formGroup]="formGroup"
    class="mb-3 row justify-center align-center gap-15px"
  >
    <button
      mat-raised-button
      type="button"
      class="mb-3"
      color="primary"
      (click)="fileInput.click()"
      [disabled]="disabled()"
      style="width: 170px"
    >
      <mat-icon>upload</mat-icon>
      <span>{{ label() }}</span>
    </button>
    <input
      #fileInput
      matInput
      type="file"
      style="position: fixed; top: -20000px"
      [accept]="accept()"
      (change)="setFile($event, controlName)"
    />
    <mat-form-field class="flex-1">
      <mat-label>URL {{ label() }}</mat-label>
      <!-- touched al escribir: sin eso el error de la URL no se ve hasta salir del campo -->
      <input
        #urlInput
        matInput
        [formControlName]="controlName"
        (input)="control?.markAsTouched()"
      />
      @if (control?.pending) {
        <mat-hint>Verificando la imagen…</mat-hint>
      } @else if (avisoUrl) {
        <mat-hint class="aviso-url">{{ avisoUrl }}</mat-hint>
      } @else if (hint()) {
        <mat-hint>{{ hint() }}</mat-hint>
      }
      @if (errorUrl) {
        <mat-error>{{ errorUrl }}</mat-error>
      }
    </mat-form-field>
    <img
      [src]="imagenes.get(controlName)?.value"
      alt="Sin Imagen"
      [style.max-width]="'100px'"
    />
  </div>
} @else {
  <!-- Modo formless: emite la URL subida -->
  <div class="centerRow">
    <div style="width: 25%">
      <button
        mat-raised-button
        type="button"
        color="primary"
        (click)="fileInput.click()"
        style="width: 90%"
      >
        <mat-icon>upload</mat-icon>
      </button>
    </div>

    <div style="width: 75%">
      <input
        #fileInput
        matInput
        type="file"
        style="position: fixed; top: -20000px"
        [accept]="accept()"
        (change)="setFileFormless($event)"
      />

      <mat-form-field>
        <mat-label>URL</mat-label>
        <input
          #urlInput
          matInput
          [value]="this.url || 'Cargando...'"
          [disabled]="true"
          style="width: 75%"
        />
      </mat-form-field>
    </div>
    <div class="centerRow">
      @if (this.url) {
        <img [src]="this.url" alt="Sin Imagen" [style.max-width]="'100px'" />
      }
    </div>
  </div>
}
